var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("scrollTop", [_c("i", { staticClass: "icon-fa icon-fa-arrow-up" })]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.showRecords.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("DateSelect", {
                      ref: "dateSelected",
                      attrs: {
                        dateRange: _vm.dateRange,
                        disabled: !!_vm.dateRange,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    !_vm.allowedDivisions
                      ? [_vm._m(1)]
                      : [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedDivision,
                                  expression: "selectedDivision",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedDivision = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.updateRunners,
                                ],
                              },
                            },
                            [
                              _c("option", { domProps: { value: 0 } }, [
                                _vm._v("Все дивизионы"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.divisionList, function (div) {
                                return _c(
                                  "option",
                                  { domProps: { value: div.id } },
                                  [_vm._v(_vm._s(div.title))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedRunner,
                                  expression: "selectedRunner",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedRunner = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: 0 } }, [
                                _vm._v("Все курьеры"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.divisionRunners,
                                function (runner, id) {
                                  return _c(
                                    "option",
                                    { domProps: { value: id } },
                                    [_vm._v(_vm._s(runner))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Показать",
                      type: "submit",
                      loading: _vm.btnLoading,
                      onClick: _vm.showRecords,
                      className: "btn btn-info m-t-10",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.btnLoading
        ? [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: { loading: true, color: _vm.loadingColor },
                  }),
                ],
                1
              ),
            ]),
          ]
        : [
            _vm.report
              ? _c("div", [
                  _vm.dayReportData
                    ? _c("div", { staticClass: "card" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              !_vm.groupFinReport && _vm.dayReportData
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6" },
                                    [
                                      _c("Saldo", {
                                        attrs: {
                                          division:
                                            _vm.dayReportData.division_id,
                                          balance: _vm.dayReportData.balance,
                                          expenses:
                                            _vm.dayReportData.reportData
                                              .expenses,
                                          incomes: [
                                            ..._vm.dayReportData.reportData
                                              .incomes.in,
                                            ..._vm.dayReportData.reportData
                                              .incomes.out,
                                          ],
                                          exchanges:
                                            _vm.dayReportData.reportData
                                              .exchanges,
                                          orders:
                                            _vm.dayReportData.orders.grouped,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.groupFinReport
                                ? [
                                    _vm.dayReportData
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6" },
                                          [
                                            _c("h6", [
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.reportDate)),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c("Calculation", {
                                              attrs: {
                                                balance:
                                                  _vm.dayReportData.balance,
                                                division:
                                                  _vm.dayReportData.division_id,
                                                divisions: {},
                                                dayData:
                                                  _vm.dayReportData.reportData,
                                                expenses:
                                                  _vm.dayReportData.reportData
                                                    .expenses,
                                                incomes: [
                                                  ..._vm.dayReportData
                                                    .reportData.incomes.in,
                                                  ..._vm.dayReportData
                                                    .reportData.incomes.out,
                                                ],
                                                exchanges:
                                                  _vm.dayReportData.reportData
                                                    .exchanges,
                                                orders:
                                                  _vm.dayReportData.orders,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c("h6", [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.reportDate)),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("hr"),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex flex-wrap" },
                                        _vm._l(
                                          _vm.dayReportData,
                                          function (report, divisionId) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "division_fin_block",
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      (_vm.$AllDivisions[
                                                        divisionId
                                                      ] &&
                                                        _vm.$AllDivisions[
                                                          divisionId
                                                        ].user.name) ||
                                                        "Не определен"
                                                    ) +
                                                      "\n                      (" +
                                                      _vm._s(
                                                        (_vm.$AllDivisions[
                                                          divisionId
                                                        ] &&
                                                          _vm.$AllDivisions[
                                                            divisionId
                                                          ].cities &&
                                                          _vm.$AllDivisions[
                                                            divisionId
                                                          ].cities[0].city
                                                            .name) ||
                                                          "не указан"
                                                      ) +
                                                      ")"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  report.balance,
                                                  function (amount, currId) {
                                                    return _c("p", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$AllCurrencies[
                                                              currId
                                                            ].currency
                                                          ) +
                                                          ": "
                                                      ),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            amount.orders.toLocaleString(
                                                              "ru-RU"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        !_vm.report.expenses || !_vm.report.expenses.length
                          ? [_vm._m(4)]
                          : [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-sm table-hover table-striped",
                                },
                                [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.report.expenses,
                                      function (exp, index) {
                                        return _c("tr", [
                                          _c("td", [_vm._v(_vm._s(index + 1))]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    !exp.to_division_id
                                                      ? "Администрация"
                                                      : _vm.$AllDivisions[
                                                          exp.to_division_id
                                                        ] &&
                                                          _vm.$AllDivisions[
                                                            exp.to_division_id
                                                          ].user.name
                                                  ) +
                                                  "\n                  "
                                              ),
                                              exp.to_division_id
                                                ? [
                                                    _vm._v(
                                                      "\n                    (" +
                                                        _vm._s(
                                                          (_vm.$AllDivisions[
                                                            exp.to_division_id
                                                          ] &&
                                                            _vm.$AllDivisions[
                                                              exp.to_division_id
                                                            ].cities &&
                                                            _vm.$AllDivisions[
                                                              exp.to_division_id
                                                            ].cities[0].city &&
                                                            _vm.$AllDivisions[
                                                              exp.to_division_id
                                                            ].cities[0].city
                                                              .name) ||
                                                            "Не указан"
                                                        ) +
                                                        ")\n                  "
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.expensesTypes[exp.type_id]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(exp.comment)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(exp.sum))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(exp.created_at)),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        !_vm.report.incomes || !_vm.report.incomes.length
                          ? [_vm._m(7)]
                          : [
                              _c(
                                "table",
                                { staticClass: "table table-sm table-striped" },
                                [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.report.incomes,
                                      function (income) {
                                        return _c("tr", { key: income.id }, [
                                          _c("td", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$AllDivisions[
                                                    income.division_id
                                                  ] &&
                                                    _vm.$AllDivisions[
                                                      income.division_id
                                                    ].user.name
                                                ) +
                                                "\n                  (" +
                                                _vm._s(
                                                  (_vm.$AllDivisions[
                                                    income.division_id
                                                  ] &&
                                                    _vm.$AllDivisions[
                                                      income.division_id
                                                    ].cities &&
                                                    _vm.$AllDivisions[
                                                      income.division_id
                                                    ].cities[0].city &&
                                                    _vm.$AllDivisions[
                                                      income.division_id
                                                    ].cities[0].city.name) ||
                                                    "Не указан"
                                                ) +
                                                ")\n                "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$AllDivisions[
                                                    income.to_division_id
                                                  ] &&
                                                    _vm.$AllDivisions[
                                                      income.to_division_id
                                                    ].user.name
                                                ) +
                                                "\n                  (" +
                                                _vm._s(
                                                  (_vm.$AllDivisions[
                                                    income.to_division_id
                                                  ] &&
                                                    _vm.$AllDivisions[
                                                      income.to_division_id
                                                    ].cities &&
                                                    _vm.$AllDivisions[
                                                      income.to_division_id
                                                    ].cities[0].city &&
                                                    _vm.$AllDivisions[
                                                      income.to_division_id
                                                    ].cities[0].city.name) ||
                                                    "Не указан"
                                                ) +
                                                ")\n                "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  income.sum.toLocaleString(
                                                    "ru-RU"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$AllCurrencies[
                                                  income.currency_id
                                                ].currency
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(income.report_date)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(income.created_at)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(income.comment)),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("RunnerReportOrders", {
                          attrs: {
                            disableEdit: true,
                            orders: _vm.report.orders,
                            runners: _vm.runners,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Ежедневный отчет")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-warning" }, [
      _vm._v(
        "\n                У Вас нет доступных дивизионов для просмотра отчета.\n                "
      ),
      _c("p", [_vm._v("Обратитесь к администратору")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Финансовые детали")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Расходы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("Расходы не найдены")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Тип расхода")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Инкассации")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("Инкассаций не найдено")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("От кого")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кому")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Валюта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Создано")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }